// import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { inView, inViewBottom } from "../helpers/layout-helpers";

import { BsArrowDown } from 'react-icons/bs';

export default function FloatingArrow() {
    const [currentSection, setCurrentSection] = useState("");
    // const [currentScrollY, setScrollY] = useState(0);
    const onScroll = (e) => {
        // setScrollY(window.scrollY);
        const sections = document.querySelectorAll(".can-scroll-to");
        const siteIntro = document.querySelector("header");
        if (!sections) return;

        if (siteIntro && inViewBottom(siteIntro)) {
            setCurrentSection("site-intro");
            return;
        }

        sections.forEach((section) => {
            //switch to children if theres nested sections

            if (inView(section)) {
                const sectionChildren =
                    section.querySelectorAll(".can-scroll-to");
                if (sectionChildren?.length > 0) {
                    sectionChildren.forEach((childSection) => {
                        if (inView(childSection)) {
                            setCurrentSection(childSection.id);
                            return;
                        }
                    });
                } else {
                    setCurrentSection(section.id);
                    return;
                }
            }
        });
    };

    useEffect(() => {
        setTimeout(() => setCurrentSection("site-intro"), 1000);
        window.addEventListener("scroll", onScroll);
        return () => {
            window.removeEventListener("scroll", onScroll);
        };
    }, []);


    let style = { position: "fixed", height: "1.25em" };
    let header = document.querySelector("header");
    let siteIntro = header?.querySelector(".site-intro");
    let menu = document.querySelector(".side-menu");
    let firstLink = menu?.querySelector("a");
    let headerTitle = header?.querySelector("h1");
    let lastLeft = firstLink?.getBoundingClientRect().right + 25;
    let minTop = firstLink?.getBoundingClientRect().top;
    let firstLeft = siteIntro?.getBoundingClientRect().width / 2;
    let firstTop = headerTitle?.getBoundingClientRect().bottom + 35;
    if (currentSection === "site-intro" && header) {
        let scrollTop = header?.getBoundingClientRect().top || 0;
        let height = header?.getBoundingClientRect().height || 0;
        let percentScrolled = ((height + scrollTop) / height) * 100;
        let left = lastLeft + ((firstLeft - lastLeft) / 100) * percentScrolled;
        let top = minTop + ((firstTop - minTop) / 100) * percentScrolled;
        let rotate = Math.floor(0.9 * (100 - percentScrolled));
        style.top = top;
        style.left = left;
        style.transform = `rotate(-${rotate}deg)`;
        style.fontSize = 1 + percentScrolled * 0.02 + "em";
        // } else if (currentSection?.classList.contains('fontarchive')) {
        //     const menuItem = currentSection.querySelector('.category-selector .active') || firstLink;
        //     style.transition = previousTarget === menuItem ? 'none' : 'all .3s ease';
        //     style.left = menuItem?.getBoundingClientRect()?.right + 25;
        //     style.top = menuItem?.getBoundingClientRect()?.top;
        //     style.transform = 'rotate(-90deg)';
    } else {
        const menuItem =
            document.querySelector(".side-menu .active") || firstLink;
        style.transition = "all .260s ease";
        style.left = menuItem?.getBoundingClientRect()?.right + 25 || 0;
        style.top = menuItem?.getBoundingClientRect()?.top || 0;
        style.transform = "rotate(-90deg)";
        style.fontSize = 1 + "em";
        style.zIndex = "20";
    }

    style.opacity = currentSection === "" ? 0 : 1;

    return (

        <div
            style={style}
            className={`floating-arrow ${currentSection !== "site-intro" ? "floating-arrow--scrolled" : ""}`}>
            <BsArrowDown
            />
        </div >
    );
}
